import { render, staticRenderFns } from "./BasicPolicies.vue?vue&type=template&id=a6b69cca&"
import script from "./BasicPolicies.vue?vue&type=script&lang=js&"
export * from "./BasicPolicies.vue?vue&type=script&lang=js&"
import style0 from "./BasicPolicies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports